(ns dashboard.components.drawer
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.utils :refer [cs]]
   ["@heroicons/react/solid" :refer [XIcon]]))

(defn drawer
  [{:keys [state title content overlay? on-close small?]
    :or {overlay? false
         on-close #(swap! state assoc :is-open? false)
         small? false}}]
  [ui/transition
   {:show (:is-open? @state)}
   [ui/dialog
    {:open (:is-open? @state)
     :as "div"
     :class "relative z-30"
     :on-close on-close}

    [:div.fixed.inset-0]
    [:div.fixed.inset-0.overflow-hidden
     [:div.absolute.inset-0.overflow-hidden
      [:div.pointer-events-none.fixed.inset-y-0.right-0.flex.max-w-full.pl-10.sm:pl-16

       [ui/transition-child
        {:enter "transform transition ease-in-out duration-500 sm:duration-700"
         :enter-from "translate-x-full"
         :enter-to "translate-x-0"
         :leave "transform transition ease-in-out duration-500 sm:duration-700"
         :leave-from "translate-x-0"
         :leave-to "translate-x-full"}

        (when overlay?
          [ui/dialog-overlay
           {:class "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"}])]

       [ui/transition-child
        {:enter "transform transition ease-in-out duration-500 sm:duration-700"
         :enter-from "translate-x-full"
         :enter-to "translate-x-0"
         :leave "transform transition ease-in-out duration-500 sm:duration-700"
         :leave-from "translate-x-0"
         :leave-to "translate-x-full"}
        [ui/dialog-panel
         {:class (cs "pointer-events-auto w-screen max-w-sm h-screen"
                     (when small? "2xl:max-w-md"))}
         [:div.flex.h-full.flex-col.divide-y.divide-gray-200.bg-white.shadow-xl
          [:div.flex.min-h-0.flex-1.flex-col.overflow-y-auto.py-6
           [:div.px-3.sm:px-4.2xl:px-6
            [:div.flex.items-start.justify-between
             [ui/dialog-title
              {:class "text-lg font-medium text-gray-900"}
              title]
             [:div.ml-3.flex.h-7.items-center
              [:button.rounded-md.bg-white.text-gray-400.hover:text-gray-500.focus:outline-none.focus:ring-2.focus:ring-primary-500
               {:type "button"
                :on-click on-close
                :tabIndex "-1"}
               [:span.sr-only
                "Close Panel"]
               [:> XIcon
                {:class "h-6 w-6"
                 :aria-hidden true}]]]]
            [:div.mt-2
             content]]]]]]]]]]])
